export default __webpack_public_path__ + "static/media/19.cca801b7.svg";